
const $ = require('jquery');
const vb = require('validation-builder');
import ko from 'rgs-knockout';
import kv from 'rgs-knockout-validation';
const Serializable = require('serializable');

function appModel (){
	const cyrrilicOnly = {
		validator: function (v) {
			v = $.trim(v);
			return !v || /^[ЁА-Я]+([ЁА-Я]*[\s\-']{0,1}[ЁА-Я]+)*$/i.test(v);
		},
		message: 'только кириллица',
	};

	const phoneFormat = {
		validator: function (v) {
			const standartPhoneLength = 11;
			v = $.trim(v);
			return v.replace(/\D/ig, "").length === standartPhoneLength;
		},
		message: 'введите корректное значение',
	};


	const vh = {
		requiredWithMsg: (msg) => {
			return {
				params: true,
				message: msg,
			};
		},
	};

	const src = new Serializable({
		Module: ko.oneOf(['Working', 'Success', 'Error']),
		InsuranceProductTypeID: ko.observable(),
		LastName: ko.observable().extend({
			required: vh.requiredWithMsg('Введите Фамилию'),
			validation: cyrrilicOnly,
			minLength: 2,
			maxLength: 50,
		}),
		FirstName: ko.observable().extend({
			required: vh.requiredWithMsg('Введите Имя'),
			validation: cyrrilicOnly,
			minLength: 2,
			maxLength: 50,
		}),
		MiddleName: ko.observable().extend({
			minLength: 2,
			validation: cyrrilicOnly,
			maxLength: 50,
		}),
		Region: ko.observable().extend({ required: vh.requiredWithMsg('Введите Регион') }),
		BankName: ko.observable().extend({ required: true }),
		Phone: ko.observable()
			.extend({
				required: vh.requiredWithMsg('Введите номер телефона'),
				validation: phoneFormat,
			}),
		Email: ko.observable()
			.extend({ email: vh.requiredWithMsg('Введите адрес электронной почты') }),
		ContactDate: ko.observable().extend({ required: vh.requiredWithMsg('Введите дату') }),
		JuridicalPersonName: ko.observable(),
		Location: ko.observable(),
		ApproximatePropertyCost: ko.observable()
		.extend({ validation: vb.all([
			vb.custom((v) => !v || /^[0-9]{1,12}((\.|,)[0-9]{2})?$/g.test(v))]),
		}),
		Comment: ko.observable(),
		PreviousPolicyNumber: ko.observable(),
		AttachedFiles: ko.observableArray(),
	});

	src.ValidationGroup = kv.computedGroup(function () {
		const product = src.Product();
		const validArray = [src.LastName, src.FirstName, src.MiddleName, src.Phone, src.Email];
		if (product.hasRegionField){
			validArray.push(src.Region);
		}

		if (!product.isQuestionPennant && !product.isCompanyProperty){
			validArray.push(src.ContactDate);
		}

		if (product.isCompanyProperty){
			validArray.push(src.ApproximatePropertyCost);
		}

		if (product.isMortgage){
			validArray.push(src.BankName);
		}

		return validArray;
	});

	src.AppTitle = '';
	src.Product = ko.observable();
	src.RegionsList = ko.observableArray();
	src.BlockButton = ko.observable(false);
	src.IsProcessingPersonalData = ko.observable(false);

	src._toJS = function () {
		const js = src.toJS();
		const contactPhoneCityCodeReg = /\d{3}(?=\))/ig;
		const contactPhoneNumberReg = /\d{3}-\d{2}-\d{2}/ig;
		js.InitialInsuranceProductType = js.InsuranceProductTypeID;
		js.Action = 'SubmitApplication';
		js.SubmitApplication = true;
		js.IsPublicArea = false;
		js.SourcePageType = 'NonCalculatorPage';
		js.ActionSource = 'LeftMenuButton';
		js.ContactPhoneCityCode = contactPhoneCityCodeReg.exec(js.Phone)[0];
		js.ContactPhoneNumber = contactPhoneNumberReg.exec(js.Phone)[0].replace(/-/gi, "");

		return js;
	};

	return { init:
		function init (options) {
			src.gtmProcessingConfig = options.gtmProcessingConfig;
			src.Module('Working');
			src.pushConversionChuteEvent = options.pushConversionChuteEvent;
			src.SubmitForm = function (){
				return options.submitForm && options.submitForm();
			};

			src.InsuranceProductTypeID(options.productName);
			src.AppTitle = options.product.appTitle;
			src.fuOptions = options.fileuploadOpt;
			src.Product(options.product);

			return src;
		},
	};
}

module.exports = appModel;
